module.exports = __webpack_public_path__ + "static/img/detailBk.61d02e24.png";